const config = {
  url: window.location.hostname === 'mall.jaboclub.com' || window.location.hostname === 'mall.jclub.com.my'
      ? 'https://mallapi.jclub.com.my/'

       : 'https://uatmallapi.jclub.com.my/'
};

export default config;